export default __webpack_public_path__ + "f8de9e946c69a5068c49186d149d268f.webp";